import React, { Component } from 'react';
import './index.less';
import anime from 'animejs';
import { Parallax, Background } from 'react-parallax';
import Utils from '../../utils/utils';
import { message } from "antd";
import Loader from '../../components/loader';
import avar from "../../assets/img/avar.png";
import avarSmile from "../../assets/img/avar-smile.png";
import bgImg from "../../assets/img/about.jpg";
import Footer from "../../components/Footer";
import Nav from '../../components/Nav/index';
import Axios from "../../axios";
import $ from 'jquery';
import Fade from 'react-reveal/Fade';
const insideStyles = {
    background: "white",
    transform: "translate(0%,0%)"
};
const rdom = require('react-dom');
export default class About extends Component{
    state = {
        isShow:false,
        isTxt:true,
        isLoading:true
    };
    componentWillMount() {
        this.aboutRequest();//获取关于
    }
    //鼠标滚动
    handleScroll(e) {
        const ele = rdom.findDOMNode(this);
        // console.log(ele)
        var eleInfo = document.getElementsByClassName('bgBox')[0];
        var expInfo = document.getElementsByClassName("about-exp")[0];
        var expHeight =$(".info-exp").height();
        var clientHeight = document.body.clientHeight;
        console.log($(".info-exp").height())
        var btn = document.getElementsByClassName("close-btn")[0];
        if (e.nativeEvent.deltaY <= 0) {
            /* scrolling up */
            if (ele.scrollTop <= 0) {
                e.preventDefault();
                // console.log('scrollingup')
                // if (timer) clearTimeout(timer);
                // step1();
                eleInfo.style.height=100+'vh';
                if(!this.state.isTxt){
                    anime.timeline({loop: 1})
                        .add({
                            targets: '.pic-exp',
                            translateY: ['22em',0],
                            opacity: [0,1],
                            easing: "easeInOutExpo",
                            duration: 500
                        })
                    this.setState({
                        isTxt:true
                    })
                }

            }
        } else {
            /* scrolling down */
            // if (timer) clearTimeout(timer);
            // step2();
            console.log( expHeight/clientHeight*100);
            console.log(100-expHeight/clientHeight*100);
            // eleInfo.style.height=(expHeight/clientHeight*100)+'vh';
            eleInfo.style.height=0+'vh';
            // expInfo.style.height = (100-expHeight/clientHeight*100)+'vh';
            if(this.state.isTxt){
                anime.timeline({loop: 1})
                    .add({
                        targets: '.pic-exp',
                        translateY: [0,'22em'],
                        opacity: [1,0],
                        easing: "easeInOutExpo",
                        duration: 500
                    })
                this.setState({
                    isTxt:false
                })
            }
            if(!this.state.isShow){
                anime.timeline({loop: 1})
                    .add({
                        targets: '.team-avar',
                        translateY: [100,0],
                        opacity: [0,1],
                        easing: "easeInOutExpo",
                        duration: 1000,
                        delay:500
                    })
                this.setState({
                    isShow:true
                })
            }
            if (ele.scrollTop + ele.clientHeight >= ele.scrollHeight) {
                e.preventDefault();
                // console.log('scrollingdown')
            }
        }
    }
    // componentWillUnmount(){
    //     window.removeEventListener('scroll', this.handleScroll);
    // }
    componentDidMount() {
        // if (document.addEventListener) {
        //     document.addEventListener('DOMMouseScroll', this.scrollFunc.bind(this), false);
        // }
        // window.onmousewheel = document.onmousewheel = this.scrollFunc.bind(this);
    }
    scrollFunc= (e) =>{ 
        e = e || window.event; 
        var eleInfo = document.getElementsByClassName('bgBox')[0];
        var expInfo = document.getElementsByClassName("about-exp")[0];
        var expHeight =$(".info-exp").height();
        var clientHeight = document.body.clientHeight;
        console.log($(".info-exp").height())
        var btn = document.getElementsByClassName("close-btn")[0];
        if (e.wheelDelta) { //第一步：先判断浏览器IE，谷歌滑轮事件    
         if (e.wheelDelta > 0) { //当滑轮向上滚动时 
        //   console.log("滑轮向上滚动"); 
        eleInfo.style.height=100+'vh';
        if(!this.state.isTxt){
            anime.timeline({loop: 1})
                .add({
                    targets: '.pic-exp',
                    translateY: ['22em',0],
                    opacity: [0,1],
                    easing: "easeInOutExpo",
                    duration: 500
                })
            this.setState({
                isTxt:true
            })
        }
         } 
         if (e.wheelDelta < 0) { //当滑轮向下滚动时 
        //   console.log("滑轮向下滚动"); 
        eleInfo.style.height=0+'vh';
        // expInfo.style.height = (100-expHeight/clientHeight*100)+'vh';
        if(this.state.isTxt){
            anime.timeline({loop: 1})
                .add({
                    targets: '.pic-exp',
                    translateY: [0,'22em'],
                    opacity: [1,0],
                    easing: "easeInOutExpo",
                    duration: 500
                })
            this.setState({
                isTxt:false
            })
        }
        if(!this.state.isShow){
            anime.timeline({loop: 1})
                .add({
                    targets: '.team-avar',
                    translateY: [100,0],
                    opacity: [0,1],
                    easing: "easeInOutExpo",
                    duration: 1000,
                    delay:500
                })
            this.setState({
                isShow:true
            })
        }
         } 
        } else if (e.detail) { //Firefox滑轮事件 
         if (e.detail> 0) { //当滑轮向上滚动时 
        //   console.log("滑轮向上滚动"); 
        eleInfo.style.height=100+'vh';
        if(!this.state.isTxt){
            anime.timeline({loop: 1})
                .add({
                    targets: '.pic-exp',
                    translateY: ['22em',0],
                    opacity: [0,1],
                    easing: "easeInOutExpo",
                    duration: 500
                })
            this.setState({
                isTxt:true
            })
        }
         } 
         if (e.detail< 0) { //当滑轮向下滚动时 
        //   console.log("滑轮向下滚动"); 
        eleInfo.style.height=0+'vh';
        // expInfo.style.height = (100-expHeight/clientHeight*100)+'vh';
        if(this.state.isTxt){
            anime.timeline({loop: 1})
                .add({
                    targets: '.pic-exp',
                    translateY: [0,'22em'],
                    opacity: [1,0],
                    easing: "easeInOutExpo",
                    duration: 500
                })
            this.setState({
                isTxt:false
            })
        }
        if(!this.state.isShow){
            anime.timeline({loop: 1})
                .add({
                    targets: '.team-avar',
                    translateY: [100,0],
                    opacity: [0,1],
                    easing: "easeInOutExpo",
                    duration: 1000,
                    delay:500
                })
            this.setState({
                isShow:true
            })
        }
         } 
        } 
       }
    animation = () =>{
        let title = document.getElementById("title");
        title.className+='show';
        setTimeout(function () {
            title.className+='hide hideElements';
            // window.scrollTo(0,1);
            setTimeout(()=>{
                title.style.height = 0+'vh';
            },2000)
        },3000)
    }
    /*列表数据请求*/
    aboutRequest = () => {
        let _this = this;
        var params = {key:"about"};
        this.setState({
            isLoading: true,
        })
        Axios.get({
            block: '/api/option',
            url: '/queryOption',
            params: params,
        }).then((data) => {
            if(data.code === 0){
                let items = data.data;
                console.log(JSON.parse(items))
                let about = JSON.parse(items);
                this.setState({
                    introduce:about.introduce,
                    member:about.member,
                    memberProfile:about.memberProfile
                })
            }else{
                message.error(data.msg)
            }
            this.setState({
                isLoading: false
            })
            // setTimeout(function () {
            //     _this.setState({
            //         isLoading: false
            //     })
            // },1000,function () {
            //
            // })
            this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };
    render() {
        const { introduce, member, memberProfile, isLoading } = this.state;
        return (
            <div>
                {
                    isLoading ? <Loader cTitle="关于" eTitle="ABOUT"/>
                        : <div className="about-cent"  style={{overflow: 'auto'}}>
                            <div className="about" id="headerImage">
                               {/* <header className="header-title">
                                    <h1 className="white">
                                        <a className="close-btn" href="/about" style={{color:'#000'}}>about</a>
                                    </h1>
                                </header>*/}
                                <div id="title" className="" style={{height:'100vh'}}>
                                  {/*  <div className="detail-info">
                                        <h4 className="about-title" id="title">Hotel Rooms Intelligent Control</h4>
                                    </div>*/}
                                    <p>
                                        <span>H</span>
                                        <span>o</span>
                                        <span>t</span>
                                        <span>e</span>
                                        <span>l </span>
                                        <span>R</span>
                                        <span>o</span>
                                        <span>o</span>
                                        <span>m</span>
                                        <span>s<b style={{marginRight:'2vw'}}></b></span>
                                        <span>I</span>
                                        <span>n</span>
                                        <span>t</span>
                                        <span>e</span>
                                        <span>l</span>
                                        <span>l</span>
                                        <span>i</span>
                                        <span>g</span>
                                        <span>e</span>
                                        <span>n</span>
                                        <span>t</span>
                                        <span><b style={{marginLeft:'2vw'}}></b>C</span>
                                        <span>o</span>
                                        <span>n</span>
                                        <span>t</span>
                                        <span>r</span>
                                        <span>o</span>
                                        <span>l</span>
                                    </p>
                                </div>
                                <div className="bgBox"  style={{backgroundImage: "url(" + bgImg + ")",height:'100vh'}}>
                                    <div className="main-image">
                                        <div className="pic-title">
                                            <h4>快智聪</h4>
                                            <p>智能家居生活领导者</p>
                                        </div>
                                        <div className="pic-exp">
                                            <h6>
                                                <Fade bottom delay={3000}>
                                                {introduce}
                                                </Fade>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="about-exp" >
                                    <div className="info-exp">
                                        <div className="left team-exp">
                                            <h4><Fade bottom>团队介绍</Fade></h4>
                                            <h6><Fade bottom cascade delay={500}>{memberProfile}</Fade></h6>
                                        </div>
                                        <div className="right team-avar">
                                            <div className="img-box">
                                                <ul>
                                                    {
                                                        member && member.map((item, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <a className="user-avar">
                                                                        <img className="pic-1"
                                                                             src={Utils.getUrl(item.commonImg)}
                                                                             alt={item.name}/>
                                                                        <img className="pic-2"
                                                                             src={Utils.getUrl(item.smileImg)}
                                                                             alt={item.name}/>
                                                                    </a>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <Footer/>
                                     {/*<Nav/>*/}
                                </div>
                                <Parallax bgImage={bgImg} strength={1000}>

                                </Parallax>
                                <Parallax strength={1000}>

                                </Parallax>
                            </div>
                        </div>
                }
            </div>
        )
    }
}
